webpackJsonp([12],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _fbemitter = __webpack_require__(10);
	
	var _sweetalert = __webpack_require__(5);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _commonMessages = __webpack_require__(6);
	
	var _commonMessages2 = _interopRequireDefault(_commonMessages);
	
	var _endpointsAccountChangeRequestService = __webpack_require__(18);
	
	var _endpointsAccountChangeRequestService2 = _interopRequireDefault(_endpointsAccountChangeRequestService);
	
	var _commonNavigation = __webpack_require__(11);
	
	var _commonNavigation2 = _interopRequireDefault(_commonNavigation);
	
	var _endpointsUrls = __webpack_require__(9);
	
	var _endpointsUrls2 = _interopRequireDefault(_endpointsUrls);
	
	var _commonUtils = __webpack_require__(3);
	
	var _commonValidators = __webpack_require__(13);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	/**
	 * This wraps the modal that initiates the registration Process
	 */
	
	var InviteModal = (function (_EventEmitter) {
	    _inherits(InviteModal, _EventEmitter);
	
	    function InviteModal(modalSelector) {
	        _classCallCheck(this, InviteModal);
	
	        _get(Object.getPrototypeOf(InviteModal.prototype), 'constructor', this).call(this);
	        this.inviteModal = (0, _jquery2['default'])(modalSelector);
	        this.theForm = this.inviteModal.find('form');
	    }
	
	    _createClass(InviteModal, [{
	        key: 'init',
	        value: function init() {
	            var self = this;
	
	            self.inviteModal.on('show.bs.modal', function (event) {
	
	                //clear specified inputs when modal is shown
	                self.inviteModal.find('label.error').remove();
	                self.inviteModal.find('.error').removeClass("error");
	
	                // InviteModal has a date-picker for the date-of-birth field, when the date-picker is open,
	                // the InviteModal's show event is being fired, despite the InviteModal being shown/open.
	                // This firing of the show event when the date-picker is open causes all the input fields to be
	                // set to null. To prevent this from happening, added a condition such that when the InviteModal
	                // is shown and the show event is triggered later due to the opening of the date-picker, do not
	                // reset the input fields to null.
	                if (!self.inviteModal.is(':visible')) {
	                    self.inviteModal.find('input:text').val('').trigger('change');
	                }
	            });
	
	            //set first input active after opening
	            self.inviteModal.on('shown.bs.modal', function () {
	                self.inviteModal.find('input').filter(':first').trigger('focus');
	            });
	
	            self.theForm.on('submit', function (e) {
	                e.preventDefault();
	
	                var theForm = self.theForm;
	                if (theForm.valid() === true) {
	                    var studentAccountChangeRequest = new _endpointsAccountChangeRequestService.StudentAccountChangeRequest(theForm.find("#invitation-email").val(), "", "", theForm.find("#invitation-firstName").val(), theForm.find("#invitation-lastName").val(), (0, _commonUtils.toISODateString)(theForm.find('#invitation-dateOfBirthString').val()));
	                    // Profile account will not have data for the "account-sub-type" attribute.
	                    self.emit('send', studentAccountChangeRequest, theForm.data('account-type'), theForm.data('account-sub-type'));
	                }
	            });
	
	            self.inviteModal.on('click', '.btn-save', function (e) {
	                e.preventDefault();
	                self.theForm.submit();
	            });
	
	            _commonValidators.dob.addMethod();
	
	            self.theForm.validate({
	                rules: {
	                    'invitation-email-confirm': {
	                        'equalTo': '#invitation-email'
	                    }
	                },
	                messages: {
	                    'invitation-email-confirm': {
	                        'equalTo': 'Email addresses must match'
	                    }
	                }
	            });
	
	            (0, _commonUtils.wireUpBootstrapDatepicker)(this.theForm, {
	                //see StudentAccountSetupSpecification.isValidBirthDate
	                startDate: (0, _moment2['default'])().subtract(100, 'years').toDate(),
	                endDate: (0, _moment2['default'])().toDate(),
	                defaultViewDate: {
	                    month: (0, _moment2['default'])().subtract(10, 'years').month(),
	                    year: (0, _moment2['default'])().subtract(10, 'years').year()
	                }
	            });
	        }
	    }, {
	        key: 'hide',
	        value: function hide() {
	            this.inviteModal.modal('hide');
	        }
	    }, {
	        key: 'toggleSendButton',
	        value: function toggleSendButton(enable) {
	            this.inviteModal.find('.btn-save').prop('disabled', enable !== true);
	        }
	    }, {
	        key: 'linkFromSendButton',
	        value: function linkFromSendButton() {
	            return this.inviteModal.find('.btn-save').data("create-account-modal-link");
	        }
	    }]);
	
	    return InviteModal;
	})(_fbemitter.EventEmitter);
	
	var openInviteModalWhenButtonClicked = function openInviteModalWhenButtonClicked() {
	    (0, _jquery2['default'])("#send-invite-modal-open-button").on("click", function () {
	        var sendInviteAlertModalSelector = '#send-invite-alert-modal';
	
	        (0, _jquery2['default'])(sendInviteAlertModalSelector).modal('hide');
	
	        (0, _jquery2['default'])(sendInviteAlertModalSelector).on('hidden.bs.modal', function () {
	            (0, _jquery2['default'])('#send-invite-modal').modal('show');
	        });
	    });
	};
	
	document.addEventListener("DOMContentLoaded", function () {
	
	    openInviteModalWhenButtonClicked();
	
	    var inviteModal = new InviteModal('#send-invite-modal');
	    inviteModal.init();
	
	    inviteModal.addListener('send', function (studentAccountChangeRequest, accountType, accountSubType) {
	
	        var isCertificationAccount = accountType === _endpointsAccountChangeRequestService.AccountType.CERTIFICATION;
	
	        var createAccountRequest = accountType === _endpointsAccountChangeRequestService.AccountType.PROFILE ? _endpointsAccountChangeRequestService2['default'].requestProfileAccount(studentAccountChangeRequest) : _endpointsAccountChangeRequestService2['default'].requestAccount(studentAccountChangeRequest);
	
	        inviteModal.toggleSendButton(false);
	
	        var createAccountModalLink = inviteModal.linkFromSendButton();
	
	        var verificationCodeLanguage = '\n                <p>Thank you. We sent instructions regarding next steps to the email address you provided.</p>\n                <p><small></small><i>Didn\'t receive a verification code?</i> Be sure to check your spam or junk folders. <a href=\'' + createAccountModalLink + '\' target=\'_blank\' className=\'btn\'>Click here</a> for assistance.</small></p>';
	
	        createAccountRequest.then(function () {
	            return inviteModal.hide();
	        }).then(function () {
	            (0, _sweetalert2['default'])({
	                title: "Email Sent",
	                html: true,
	                text: verificationCodeLanguage,
	                type: "info",
	                confirmButtonColor: "#DD6B55",
	                confirmButtonText: "Continue"
	            }, function () {
	                var encodedEmail = encodeURIComponent(studentAccountChangeRequest.email);
	                var completeRegistrationUrl = '/register/completeRegistration?emailAddress=' + encodedEmail;
	                if (isCertificationAccount) {
	                    completeRegistrationUrl += '&accountSubType=' + accountSubType;
	                }
	                _commonNavigation2['default'].goto(completeRegistrationUrl);
	            });
	        })['catch'](function (error) {
	            (0, _sweetalert2['default'])({
	                title: "Error",
	                text: 'We were unable to send your invite. ' + _commonMessages2['default'].CONTACT_SUPPORT,
	                type: "error",
	                confirmButtonText: "Ok" });
	        })['finally'](function () {
	            return inviteModal.toggleSendButton(true);
	        });
	    });
	});

/***/ })
]);


// WEBPACK FOOTER //
// create-account-start-page.js